/** useTabState Hook - Unified tab state management */

import { useState, useCallback } from 'react';

/**
 * useTabState - Simplifies tab state management
 * 
 * Usage:
 * const tabs = useTabState('dashboard'); // Initial tab
 * 
 * tabs.activeTab - Current active tab
 * tabs.setActiveTab(tab) - Change tab
 * tabs.isActive(tab) - Check if tab is active
 * 
 * @param {string} initialTab - Initial active tab
 * @returns {object} Tab state and handlers
 */
export const useTabState = (initialTab = '') => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const isActive = useCallback((tab) => activeTab === tab, [activeTab]);

  const switchTab = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  return {
    activeTab,
    setActiveTab: switchTab,
    isActive
  };
};

export default useTabState;
